export default {
  'global.contract_not_bound': '合同未绑定',
  'global.returnHome' : '返回首页',
  'global.name': '名称',
  'global.description': '描述',
  'global.updatedtime': '更新时间',
  'global.createdtime': '创建时间',
  'global.new': '新建',
  'global.searchText': '搜索',
  'global.resetText': '重置',
  'global.operation': '操作',
  'global.confirmDelete': '确认删除该项吗?',
  'global.confirm': '确定',
  'global.cancel': '取消',
  'global.save': '保存',
  'global.update': '更新',
  'global.delete': '删除',
  'global.company': '公司',
  'global.partner': '合作方',
  'global.email': '邮箱',
  'global.customer': '客户',
  'global.rank': '排名',
  'global.country': '国家',
  'global.download': '下载',
  
  //-- 应用相关指标
  'global.dau': '日活跃用户数',
  'global.mau': '月活跃用户数',
  'global.totalUsers': '总用户数',
  'global.totalPlayDuration': '总播放时长',
  'global.playDuration': '观看时长(h)',
  'global.totalPlayCount': '总播放次数',
  'global.playCount': '播放次数',
  'global.totalPlayUsers': '总播放用户数',
  'global.playUsers': '播放用户数',
  'global.dailyActiveUsers': '日活跃用户数',
  'global.averageActiveUsers': '平均活跃用户数',
  'global.totalContentDeeplinkClick': 'Deeplink点击数',
  'global.top10DeeplinkContents': 'Deeplink点击Top10的频道',
  'global.top10ChannelsPreferredByUsers': '用户最喜欢的10个频道',
  'global.avgEngagementTimePerActiveUser': '活跃用户平均使用时间',
  'global.usersByTop10Countries': '用户数Top10的国家',
  'global.revenueByTop10Countries': '收入Top10的国家',
  'global.totalAppUsageTime': '应用使用时间',
  'global.top10CustomerRevenue': '收入Top10的渠道',
  'global.image': '封面图',
  'global.title': '标题',
  'global.category': '分类',
  'global.trend': '趋势',
  'global.channelAnalytics': '频道数据',
  'global.dimensions': '维度',
  'global.metrics': '指标',
  'global.filters': '筛选',
  'global.channelName': '渠道名称',
  'global.channelCategory': '渠道分类',


  //-- 广告相关指标多语言
  'global.adIndex': '广告位',
  'global.adRequests': '广告请求',
  'global.impressions' : '广告曝光',
  'global.ecpm' : '千次曝光收入($)',
  'global.ecpmRevenue': '广告收入($)',
  'global.nonEcpmRevenue': '非广告收入($)',
  'global.totalRevenue': '总收入($)',
  'global.netRevenue': '净收入($)',
  'global.grossRevenue': '总收入($)',


  //-- 时间相关多语言
  'global.customDateRange': '自定义时间',
  'global.yesterday': '昨天',
  'global.last7days': '最近7天',
  'global.last14days': '最近14天',
  'global.thisMonth': '本月',
  'global.lastMonth': '上月',
  'global.last3Month': '最近3月',
  'global.last6Month': '最近6月',
  'global.last12Month': '最近12月',
  'global.day': '天',
  'global.week': '周',
  'global.month': '月',
  'global.year': '年',
  'global.date': '日期',

};
